import { GQL } from '../graphQl'

export const getTenantConfig = () => GQL`query getTenantConfig($conditions: tenant_defaults_bool_exp) {
  tenant_defaults(where: $conditions) {
    tenant_feature_configuration
    tenant_id
  }
}`
